import React, { useEffect } from "react"

import { generateDocumentTitle } from "../../../constants/document-title.ts"
import { ROLE_IDS } from "../../../constants/roles.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import { SmsUsagePanel } from "../components/settings-sms-usage/SmsUsagePanel.tsx"

export default function SettingsSmsUsagePage() {
  const roleId = useAppSelector((state) => state.auth.userInfo?.role?.id)

  useEffect(() => {
    generateDocumentTitle("Settings SMS Usage")
  }, [])

  return <SmsUsagePanel platform={roleId === ROLE_IDS.ADMIN_PLATFORM} />
}
